module.exports = __webpack_public_path__ + "static/img/top-bgc.d07b8425.png";